import { useCallback } from "react"
import {
  Block,
  Button,
  LabelLarge,
  Tag02,
  useStyletron,
} from "@mezo-org/mezo-clay"

import {
  selectCollectedProducts,
  setCurrentProduct,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { StoreItem } from "#/shared/constants"

export default function MarketItem({
  id,
  name,
  description,
  price,
  image,
  fullImage,
}: StoreItem) {
  const collectedProducts = useDappSelector(selectCollectedProducts)
  const dispatch = useDappDispatch()

  const [css, theme] = useStyletron()

  const itemClickHandler = useCallback(() => {
    dispatch(setOpenModal("store-item"))
    dispatch(
      setCurrentProduct({ id, name, description, price, image, fullImage }),
    )
  }, [dispatch, id, name, description, price, image, fullImage])

  const isCollected = collectedProducts.includes(id)

  return (
    <Block
      onClick={itemClickHandler}
      className={css({
        height: "100%",
        cursor: "pointer",
        borderRadius: theme.borders.radius400,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        ":hover .image-container": { width: "110%" },
      })}
    >
      <Block
        width="100%"
        height="255px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        className={
          // eslint-disable-next-line prefer-template
          css({
            transition: "0.3s ease",
          }) + " image-container"
        }
      >
        <Block
          as="img"
          width="100%"
          height="100%"
          src={image}
          alt={name}
          className={css({ objectFit: "cover" })}
        />
      </Block>
      <Block
        width="100%"
        className={css({
          padding: theme.sizing.scale800,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: theme.sizing.scale800,
          background: theme.colors.white,
          borderRadius: theme.borders.radius400,
          flex: 1,
        })}
      >
        <LabelLarge>{name}</LabelLarge>
        <Button
          shape="pill"
          size="small"
          disabled={isCollected}
          onClick={itemClickHandler}
          startEnhancer={
            isCollected ? null : <Tag02 color={theme.colors.white} size={16} />
          }
        >
          {isCollected ? "Collected" : `${price} MUSD`}
        </Button>
      </Block>
    </Block>
  )
}
